import axios from "axios";
import { BASE_URL } from "../services/constant";

export const META_PIXEL_EVENTS = {
  VIEW_CONTENT: "ViewContent",
  ADD_TO_CART: "AddToCart",
  INITIATE_CHECKOUT: "InitiateCheckout",
  ADD_PAYMENT_INFO: "AddPaymentInfo",
  PURCHASE: "Purchase",
  LEAD: "Lead",
};

export const getCookie = (name) => {
  if (typeof document === "undefined") return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

export const getMetaCookies = () => {
  return {
    fbp: getCookie("_fbp") || (typeof localStorage !== "undefined" ? localStorage.getItem("_fbp") : null) || null,
    fbc: getCookie("_fbc") || (typeof localStorage !== "undefined" ? localStorage.getItem("_fbc") : null) || null,
  };
};

export const captureFbclid = () => {
  if (typeof window === "undefined") return;
  const urlParams = new URLSearchParams(window.location.search);
  const fbclid = urlParams.get("fbclid");
  if (fbclid) {
    const creationTime = Date.now();
    const fbcValue = `fb.1.${creationTime}.${fbclid}`;
    document.cookie = `_fbc=${fbcValue}; path=/; max-age=7776000`; // 90 days
    if (typeof localStorage !== "undefined") {
      localStorage.setItem("_fbc", fbcValue);
    }
  }
};

export const generateEventId = (prefix = "ev") => {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
};

const getNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const buildCartEventPayload = (items = [], extra = {}) => {
  const cleanItems = items.filter(Boolean);
  const contents = cleanItems.map((item) => {
    const id = item.product_id || item.id || item.productId;
    const quantity = getNumber(item.quantity) || 1;
    const price = getNumber(item.price);

    return {
      id: String(id || ""),
      quantity,
      item_price: price,
    };
  });
  const value = cleanItems.reduce(
    (total, item) => total + getNumber(item.price) * (getNumber(item.quantity) || 1),
    0
  );
  const contentIds = contents.map((item) => item.id).filter(Boolean);
  const firstItem = cleanItems[0] || {};

  return {
    currency: "INR",
    value,
    content_ids: contentIds,
    content_type: "product",
    contents,
    content_name:
      firstItem.product_name ||
      firstItem.name ||
      (cleanItems.length > 1 ? "Cart Items" : "Kuku Product"),
    num_items: cleanItems.reduce(
      (total, item) => total + (getNumber(item.quantity) || 1),
      0
    ),
    ...extra,
  };
};

export const trackMetaEvent = (eventName, payload = {}, options = {}) => {
  const eventId = options.eventId || payload.order_id || generateEventId(eventName.toLowerCase());
  const userData = options.userData || {};

  // 1. Browser Meta Pixel Event
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", eventName, payload, { eventID: String(eventId) });
    console.log(`[Meta Pixel Browser] Tracked '${eventName}'`, { payload, eventId });
  }

  // 2. Server-side CAPI Call via Backend Endpoint
  try {
    const metaCookies = getMetaCookies();
    const trackingApiUrl = `${BASE_URL.replace(/\/+$/, "")}/tracking/meta-event`;

    axios.post(trackingApiUrl, {
      event_name: eventName,
      event_id: String(eventId),
      event_source_url: typeof window !== "undefined" ? window.location.href : null,
      user_data: {
        ...userData,
        fbp: metaCookies.fbp,
        fbc: metaCookies.fbc,
      },
      custom_data: payload,
    }).then(res => {
      console.log(`[Meta CAPI Server] Tracked '${eventName}'`, res.data);
    }).catch(err => {
      console.warn(`[Meta CAPI Server Warning] Could not send CAPI event '${eventName}'`, err?.message);
    });
  } catch (e) {
    console.warn(`[Meta CAPI Warning] Error dispatching server event '${eventName}'`, e?.message);
  }

  return true;
};